
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as cercaqjQi4H7ybd1Q55vl8yxDP4T1XaPLq1ajL0PNmXo7bjgMeta } from "/app/app/pages/cerca.vue?macro=true";
import { default as agendaKRuMGFn_68LYUIs70h866r6p6CEFN6fgTOuevvKrm0IMeta } from "/app/app/pages/agenda.vue?macro=true";
import { default as carrelloBvZ5_uwrWLeKuJ5lUxFed91mhwtEX5q0XUVhaUUYYmAMeta } from "/app/app/pages/carrello.vue?macro=true";
import { default as _91_46_46_46slug_93eDHq9Sb_fpMilQ4SKVcOZkf94gCZN8K0Lr0WXAEt9UMMeta } from "/app/app/pages/[...slug].vue?macro=true";
import { default as _91id_93ElLNocnKICvSKc8aW8NoTapKv_fmDo9iUHWQ2uz7FnAMeta } from "/app/app/pages/node/[id].vue?macro=true";
import { default as me16225tHgQWzP8Vw05jNeFwuT_HVSveYxNw8ER_vEHBoMeta } from "/app/app/pages/dashboard/me.vue?macro=true";
import { default as index7W_5ibQCwfyFCnoS3kmrLhWU_cCCH__wROzrkubOp5gMeta } from "/app/app/pages/visita/index.vue?macro=true";
import { default as _91id_93DimaqBkNT_mn_nLd12tGI0qlBypEd7E_gpoOjrYTOzsMeta } from "/app/app/pages/l/eventi/[id].vue?macro=true";
import { default as _91id_933RUYuPbD_xoJgawSFULuPTJe9zwtyunN5Ku8z18fETIMeta } from "/app/app/pages/l/pagine/[id].vue?macro=true";
import { default as indextuxD9i30ur3bawJlePRY341J_J7eXdwpjTspY2246F0Meta } from "/app/app/pages/checkout/index.vue?macro=true";
import { default as _91id_93kOQ83mYfJAh2jbXBVcrkcaXGN_sRWPJ5RbEt5ZMTshEMeta } from "/app/app/pages/l/risorse/[id].vue?macro=true";
import { default as indexHWEmjiDKPskAN33Lg_lMx0dXo3K00Q9NUQaYRXp6llgMeta } from "/app/app/pages/dashboard/index.vue?macro=true";
import { default as _91id_9334WaQVDEXLoPxVcRZ_WQktb8Jlqgr_j1ttsBSKBlRJIMeta } from "/app/app/pages/l/attivita/[id].vue?macro=true";
import { default as _91id_93VOo8tAJ7b4lhDIC0jzF0QiCws3Jc5b1aMLbg_Dr_PbAMeta } from "/app/app/pages/l/prodotti/[id].vue?macro=true";
import { default as _91id_93NitQcLjF23CxHh8sUWdOUIoWD5Q0vNMaWluNg4WWtq4Meta } from "/app/app/pages/l/pacchetti/[id].vue?macro=true";
import { default as _91id_933r9wo8L_Zb_eM4Bxf4N6OYLU05ZaxhP5xHltG9q2y8YMeta } from "/app/app/pages/l/spettacoli/[id].vue?macro=true";
import { default as _91id_93tCWqdqo8_EQoLY55Kg6ZOy6juZ0j5I9zLUOQxlVWdSYMeta } from "/app/app/pages/preview/eventi/[id].vue?macro=true";
import { default as _91id_93oa1Z8Ipykx_hs31ogv_6q4ztZJjF7e9bHdzxHRxBL6gMeta } from "/app/app/pages/preview/pagine/[id].vue?macro=true";
import { default as traduzione_45mancantekm_Xp6v0AhhZFLQUdY2oxjSUxrnRM0QlUHAseGFJTOAMeta } from "/app/app/pages/traduzione-mancante.vue?macro=true";
import { default as _91id_93AzVQakL5tEbsAZQt0d4PQY9I8XpEjlcPeNSvEf1D088Meta } from "/app/app/pages/acquista/[tipo]/[id].vue?macro=true";
import { default as _91id_93edd5tvjJKNR0ms7AKdA9VW3oZll4ljnC0hkB7G7go9AMeta } from "/app/app/pages/acquista/bundle/[id].vue?macro=true";
import { default as _91id_93_rPQbsEboOctxWpVWXR6JZP9rh5GaJ0aZEvV2kyUvf4Meta } from "/app/app/pages/preview/risorse/[id].vue?macro=true";
import { default as invitoqGuSOOjS_bBaeoZn9pjIR3cjuDK9EzlPC3uQWhRj1CMMeta } from "/app/app/pages/registrazione/invito.vue?macro=true";
import { default as indexBIYt6aSQiGyT0t_Mj2bdd5Y1ASVqqsjKu5Pa_qXTkH8Meta } from "/app/app/pages/dashboard/login/index.vue?macro=true";
import { default as reset4xSMxY8nY4xJmSAixpmYM98TvQ9zixr0Ou_YAaL8oFIMeta } from "/app/app/pages/dashboard/login/reset.vue?macro=true";
import { default as maintenance04R_6Z6ehX3nFmuhwxisd4WxgkNvokphXKJRv8uPnZAMeta } from "/app/app/pages/dashboard/maintenance.vue?macro=true";
import { default as _91id_93Opr2RsamzI2Q9KAHewnTWn6hyna8A6up2XYDh6Vzup0Meta } from "/app/app/pages/l/visite_guidate/[id].vue?macro=true";
import { default as _91id_93CzopvxhvPIP8hcXf04H3V880q_sqyYF06zx_yqc25OoMeta } from "/app/app/pages/preview/attivita/[id].vue?macro=true";
import { default as _91id_93c2sVWQcfrAUx8RKU6XfZwPM3chE6Iphq9XZqDAhPCSkMeta } from "/app/app/pages/preview/prodotti/[id].vue?macro=true";
import { default as forgotSga88m7JXw5894qmLorzzwEsbvWD9jMSdtZAGfem3vkMeta } from "/app/app/pages/dashboard/login/forgot.vue?macro=true";
import { default as _91id_93zagP70MVFDWXNETfVKAbJkhbmNozW3Se6Ogc2e90mH8Meta } from "/app/app/pages/l/news_convention/[id].vue?macro=true";
import { default as _91id_93tHFM3gbcRcbU4FMhrdzavBavJaeyOQu4PX7GZRg82coMeta } from "/app/app/pages/preview/pacchetti/[id].vue?macro=true";
import { default as indexUUQ1DbIl8Mi8GUot0AkD_32LBR8LtWzFU68juLoVSI0Meta } from "/app/app/pages/dashboard/outdoor/index.vue?macro=true";
import { default as index0mor4myQADOZdY4LBeRsOWqgX_HIGsDeXRkwmX5TDuEMeta } from "/app/app/pages/dashboard/incoming/index.vue?macro=true";
import { default as _91ordine_93K9Obgk0l0iOa7HcIYrES_HXKkwbJzWXRvVxHbyMmpGEMeta } from "/app/app/pages/checkout/success/[ordine].vue?macro=true";
import { default as acquistaTDjwd_GsF0aQs_ZHJjcEVzd9O3v7_j2I2VUqFC1qQAEMeta } from "/app/app/pages/dashboard/armonia/acquista.vue?macro=true";
import { default as gestisci3TvQswV648MW00rMpEyKuzxj83vLbLz_C9C9JF2QqP0Meta } from "/app/app/pages/dashboard/armonia/gestisci.vue?macro=true";
import { default as modificayOFq19irKKw3egUUmH0M8_ngIiHSMlPPKkfh7Ni8rx8Meta } from "/app/app/pages/dashboard/profilo/modifica.vue?macro=true";
import { default as _91id_93eQsryJZZt7cvWD_gvMd2poTrfSxjY5lggzirVQRVJTEMeta } from "/app/app/pages/preview/visite-guidate/[id].vue?macro=true";
import { default as _91id_93w85apaYerdealQtk8nilZhmQ1ZhxVU2XRpplRlf809AMeta } from "/app/app/pages/acquista/visite-guidate/[id].vue?macro=true";
import { default as indexDLptPdQi54uCxbSOySJeP0M1TH3F39380NZ6I6Qz4SMMeta } from "/app/app/pages/dashboard/outdoor/crea/index.vue?macro=true";
import { default as index5CL06asLTOC0JGZdzpstfde036UhYeV8_ZzMHOYN3BYMeta } from "/app/app/pages/dashboard/profilo/card/index.vue?macro=true";
import { default as index_zGcqVDaYvT4gCZOBBP1glhKZoAOybVRVVNIr_uU_uYMeta } from "/app/app/pages/dashboard/ristorazione/index.vue?macro=true";
import { default as indexjTQxzQYLpATwvXGjC1QG1EfyCrgqdyeh8_Q1Md5mXfUMeta } from "/app/app/pages/dashboard/incoming/crea/index.vue?macro=true";
import { default as index_yQx7j8LkhYZe47AD3iVSyj1kyJxv4z_yMVSJ1G39Y8Meta } from "/app/app/pages/dashboard/registrazione/index.vue?macro=true";
import { default as indexlCzHGIUWo2IeK8YBneozvA5VGR7lrTbkz_WJgwoq3R4Meta } from "/app/app/pages/dashboard/profilo/ordini/index.vue?macro=true";
import { default as invitoHFsh6fZ5GwqtcK8LAnVMCxTRsTpiYq39l7X0wh_OUuMMeta } from "/app/app/pages/dashboard/registrazione/invito.vue?macro=true";
import { default as _91id_93Q0J2DaUt6AXZY6eqGiz_TTuTd0kXBDTrgLrsIrqk81UMeta } from "/app/app/pages/dashboard/outdoor/modifica/[id].vue?macro=true";
import { default as registrazione_4a2nu1Wh0Kc6XM_SX_HjG3zl1ucqCu9QPoFSRFBtSgMeta } from "/app/app/pages/dashboard/outdoor/registrazione.vue?macro=true";
import { default as index3VHBz3a7tinFE2cmKpoQcgsQLb9W512lyT_MmcITSlgMeta } from "/app/app/pages/dashboard/promuovi-evento/index.vue?macro=true";
import { default as _91id_93_VbHvoCUj2GSAt4BBxFVJo65i199c_MQoBfnqCadFSkMeta } from "/app/app/pages/dashboard/incoming/modifica/[id].vue?macro=true";
import { default as registrazioneVr6oCKXL06SX37_OfoXtB7rYxD3DGzx_y0izKrvkVJoMeta } from "/app/app/pages/dashboard/incoming/registrazione.vue?macro=true";
import { default as indexWFz_iFhGdYmo7knMuPI5US9K5o_gE_HIlq4_ix12ZPAMeta } from "/app/app/pages/dashboard/ristorazione/crea/index.vue?macro=true";
import { default as indexjZb_0GXtVnm1wOCkiTIAGiMsBa1wTQHUydEPQ43pohAMeta } from "/app/app/pages/dashboard/armonia/calendario/index.vue?macro=true";
import { default as indexcNGqCk6unrleXkAABP9e2fmizSV7Tiw3xtvCrtZ3VQ4Meta } from "/app/app/pages/dashboard/profilo/prenotazioni/index.vue?macro=true";
import { default as _91id_93aH4pAAQI__mHcvTKNytTb3Oiq7536V9_9ZSkB5f5BdwMeta } from "/app/app/pages/dashboard/ristorazione/modifica/[id].vue?macro=true";
import { default as indexH8k0nBO3MLKbykhUTssNRvV6Atuty_s2VY_ghpT1MxAMeta } from "/app/app/pages/dashboard/promuovi-ristorazione/index.vue?macro=true";
import { default as indexoVscpuxboA_dpPgplfT_tJ6TnJG7ZL76TBqiBEdWwmYMeta } from "/app/app/pages/dashboard/armonia/calendario/[slug]/index.vue?macro=true";
import { default as prenotasweGuHFLhX5__w6CvxYej9xSWNiLd0U84AxW2OVDOe0Meta } from "/app/app/pages/dashboard/armonia/calendario/[slug]/prenota.vue?macro=true";
import { default as _91id_93eEpeQz1M83dcFq4CwDDXodTLXgzpsyVMgOL5HIWnFkkMeta } from "/app/app/pages/dashboard/profilo/card/abbonamenti-athena/[id].vue?macro=true";
import { default as torino_45piemonte_45card_nprFiEv0ojirWFi3qY9XOU_5pX02G1b5ZLlhW3ZhM8Meta } from "/app/app/pages/visita/pianifica-la-tua-visita/torino-piemonte-card.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "cerca___it",
    path: "/it/cerca",
    component: () => import("/app/app/pages/cerca.vue")
  },
  {
    name: "cerca___en",
    path: "/en/cerca",
    component: () => import("/app/app/pages/cerca.vue")
  },
  {
    name: "cerca___fr",
    path: "/fr/cerca",
    component: () => import("/app/app/pages/cerca.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "agenda___it",
    path: "/it/agenda",
    meta: agendaKRuMGFn_68LYUIs70h866r6p6CEFN6fgTOuevvKrm0IMeta || {},
    component: () => import("/app/app/pages/agenda.vue")
  },
  {
    name: "agenda___en",
    path: "/en/agenda",
    meta: agendaKRuMGFn_68LYUIs70h866r6p6CEFN6fgTOuevvKrm0IMeta || {},
    component: () => import("/app/app/pages/agenda.vue")
  },
  {
    name: "agenda___fr",
    path: "/fr/agenda",
    meta: agendaKRuMGFn_68LYUIs70h866r6p6CEFN6fgTOuevvKrm0IMeta || {},
    component: () => import("/app/app/pages/agenda.vue")
  },
  {
    name: "carrello___it",
    path: "/it/carrello",
    meta: {"middleware":["carrello"]},
    component: () => import("/app/app/pages/carrello.vue")
  },
  {
    name: "carrello___en",
    path: "/en/carrello",
    meta: {"middleware":["carrello"]},
    component: () => import("/app/app/pages/carrello.vue")
  },
  {
    name: "carrello___fr",
    path: "/fr/carrello",
    meta: {"middleware":["carrello"]},
    component: () => import("/app/app/pages/carrello.vue")
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    component: () => import("/app/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/app/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/app/app/pages/[...slug].vue")
  },
  {
    name: "node-id",
    path: "/node/:id()",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "dashboard-me___it",
    path: "/it/dashboard/me",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/me.vue")
  },
  {
    name: "dashboard-me___en",
    path: "/en/dashboard/me",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/me.vue")
  },
  {
    name: "dashboard-me___fr",
    path: "/fr/dashboard/me",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/me.vue")
  },
  {
    name: "visita___it",
    path: "/it/visita",
    meta: index7W_5ibQCwfyFCnoS3kmrLhWU_cCCH__wROzrkubOp5gMeta || {},
    component: () => import("/app/app/pages/visita/index.vue")
  },
  {
    name: "visita___en",
    path: "/en/visit",
    meta: index7W_5ibQCwfyFCnoS3kmrLhWU_cCCH__wROzrkubOp5gMeta || {},
    component: () => import("/app/app/pages/visita/index.vue")
  },
  {
    name: "visita___fr",
    path: "/fr/decouvrir",
    meta: index7W_5ibQCwfyFCnoS3kmrLhWU_cCCH__wROzrkubOp5gMeta || {},
    component: () => import("/app/app/pages/visita/index.vue")
  },
  {
    name: "l-eventi-id",
    path: "/l/eventi/:id()",
    component: () => import("/app/app/pages/l/eventi/[id].vue")
  },
  {
    name: "l-pagine-id",
    path: "/l/pagine/:id()",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/l/pagine/[id].vue")
  },
  {
    name: "checkout___it",
    path: "/it/checkout",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___en",
    path: "/en/checkout",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/checkout/index.vue")
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/checkout/index.vue")
  },
  {
    name: "l-risorse-id",
    path: "/l/risorse/:id()",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/l/risorse/[id].vue")
  },
  {
    name: "dashboard___it",
    path: "/it/dashboard",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/index.vue")
  },
  {
    name: "dashboard___en",
    path: "/en/dashboard",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/index.vue")
  },
  {
    name: "dashboard___fr",
    path: "/fr/dashboard",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/index.vue")
  },
  {
    name: "l-attivita-id___it",
    path: "/it/l/attivita/:id()",
    component: () => import("/app/app/pages/l/attivita/[id].vue")
  },
  {
    name: "l-attivita-id___en",
    path: "/en/l/attivita/:id()",
    component: () => import("/app/app/pages/l/attivita/[id].vue")
  },
  {
    name: "l-attivita-id___fr",
    path: "/fr/l/attivita/:id()",
    component: () => import("/app/app/pages/l/attivita/[id].vue")
  },
  {
    name: "l-prodotti-id",
    path: "/l/prodotti/:id()",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/l/prodotti/[id].vue")
  },
  {
    name: "l-pacchetti-id",
    path: "/l/pacchetti/:id()",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/l/pacchetti/[id].vue")
  },
  {
    name: "l-spettacoli-id",
    path: "/l/spettacoli/:id()",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/l/spettacoli/[id].vue")
  },
  {
    name: "preview-eventi-id___it",
    path: "/it/preview/eventi/:id()",
    component: () => import("/app/app/pages/preview/eventi/[id].vue")
  },
  {
    name: "preview-eventi-id___en",
    path: "/en/preview/eventi/:id()",
    component: () => import("/app/app/pages/preview/eventi/[id].vue")
  },
  {
    name: "preview-eventi-id___fr",
    path: "/fr/preview/eventi/:id()",
    component: () => import("/app/app/pages/preview/eventi/[id].vue")
  },
  {
    name: "preview-pagine-id___it",
    path: "/it/preview/pagine/:id()",
    component: () => import("/app/app/pages/preview/pagine/[id].vue")
  },
  {
    name: "preview-pagine-id___en",
    path: "/en/preview/pagine/:id()",
    component: () => import("/app/app/pages/preview/pagine/[id].vue")
  },
  {
    name: "preview-pagine-id___fr",
    path: "/fr/preview/pagine/:id()",
    component: () => import("/app/app/pages/preview/pagine/[id].vue")
  },
  {
    name: "traduzione-mancante___it",
    path: "/it/traduzione-mancante",
    component: () => import("/app/app/pages/traduzione-mancante.vue")
  },
  {
    name: "traduzione-mancante___en",
    path: "/en/missing-translation",
    component: () => import("/app/app/pages/traduzione-mancante.vue")
  },
  {
    name: "traduzione-mancante___fr",
    path: "/fr/traduction-manquante",
    component: () => import("/app/app/pages/traduzione-mancante.vue")
  },
  {
    name: "acquista-tipo-id___it",
    path: "/it/acquista/:tipo()/:id()",
    meta: {"middleware":["acquista-prodotto"]},
    component: () => import("/app/app/pages/acquista/[tipo]/[id].vue")
  },
  {
    name: "acquista-tipo-id___en",
    path: "/en/acquista/:tipo()/:id()",
    meta: {"middleware":["acquista-prodotto"]},
    component: () => import("/app/app/pages/acquista/[tipo]/[id].vue")
  },
  {
    name: "acquista-tipo-id___fr",
    path: "/fr/acquista/:tipo()/:id()",
    meta: {"middleware":["acquista-prodotto"]},
    component: () => import("/app/app/pages/acquista/[tipo]/[id].vue")
  },
  {
    name: "acquista-bundle-id___it",
    path: "/it/acquista/bundle/:id()",
    component: () => import("/app/app/pages/acquista/bundle/[id].vue")
  },
  {
    name: "acquista-bundle-id___en",
    path: "/en/acquista/bundle/:id()",
    component: () => import("/app/app/pages/acquista/bundle/[id].vue")
  },
  {
    name: "acquista-bundle-id___fr",
    path: "/fr/acquista/bundle/:id()",
    component: () => import("/app/app/pages/acquista/bundle/[id].vue")
  },
  {
    name: "preview-risorse-id___it",
    path: "/it/preview/risorse/:id()",
    component: () => import("/app/app/pages/preview/risorse/[id].vue")
  },
  {
    name: "preview-risorse-id___en",
    path: "/en/preview/risorse/:id()",
    component: () => import("/app/app/pages/preview/risorse/[id].vue")
  },
  {
    name: "preview-risorse-id___fr",
    path: "/fr/preview/risorse/:id()",
    component: () => import("/app/app/pages/preview/risorse/[id].vue")
  },
  {
    name: "registrazione-invito___it",
    path: "/it/registrazione/invito",
    meta: invitoqGuSOOjS_bBaeoZn9pjIR3cjuDK9EzlPC3uQWhRj1CMMeta || {},
    component: () => import("/app/app/pages/registrazione/invito.vue")
  },
  {
    name: "registrazione-invito___en",
    path: "/en/registrazione/invito",
    meta: invitoqGuSOOjS_bBaeoZn9pjIR3cjuDK9EzlPC3uQWhRj1CMMeta || {},
    component: () => import("/app/app/pages/registrazione/invito.vue")
  },
  {
    name: "registrazione-invito___fr",
    path: "/fr/registrazione/invito",
    meta: invitoqGuSOOjS_bBaeoZn9pjIR3cjuDK9EzlPC3uQWhRj1CMMeta || {},
    component: () => import("/app/app/pages/registrazione/invito.vue")
  },
  {
    name: "dashboard-login___it",
    path: "/it/dashboard/login",
    component: () => import("/app/app/pages/dashboard/login/index.vue")
  },
  {
    name: "dashboard-login___en",
    path: "/en/dashboard/login",
    component: () => import("/app/app/pages/dashboard/login/index.vue")
  },
  {
    name: "dashboard-login___fr",
    path: "/fr/dashboard/login",
    component: () => import("/app/app/pages/dashboard/login/index.vue")
  },
  {
    name: "dashboard-login-reset___it",
    path: "/it/dashboard/login/reset",
    meta: {"middleware":["reset-password"]},
    component: () => import("/app/app/pages/dashboard/login/reset.vue")
  },
  {
    name: "dashboard-login-reset___en",
    path: "/en/dashboard/login/reset",
    meta: {"middleware":["reset-password"]},
    component: () => import("/app/app/pages/dashboard/login/reset.vue")
  },
  {
    name: "dashboard-login-reset___fr",
    path: "/fr/dashboard/login/reset",
    meta: {"middleware":["reset-password"]},
    component: () => import("/app/app/pages/dashboard/login/reset.vue")
  },
  {
    name: "dashboard-maintenance___it",
    path: "/it/dashboard/maintenance",
    meta: maintenance04R_6Z6ehX3nFmuhwxisd4WxgkNvokphXKJRv8uPnZAMeta || {},
    component: () => import("/app/app/pages/dashboard/maintenance.vue")
  },
  {
    name: "dashboard-maintenance___en",
    path: "/en/dashboard/maintenance",
    meta: maintenance04R_6Z6ehX3nFmuhwxisd4WxgkNvokphXKJRv8uPnZAMeta || {},
    component: () => import("/app/app/pages/dashboard/maintenance.vue")
  },
  {
    name: "dashboard-maintenance___fr",
    path: "/fr/dashboard/maintenance",
    meta: maintenance04R_6Z6ehX3nFmuhwxisd4WxgkNvokphXKJRv8uPnZAMeta || {},
    component: () => import("/app/app/pages/dashboard/maintenance.vue")
  },
  {
    name: "l-visite_guidate-id",
    path: "/l/visite_guidate/:id()",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/l/visite_guidate/[id].vue")
  },
  {
    name: "preview-attivita-id___it",
    path: "/it/preview/attivita/:id()",
    component: () => import("/app/app/pages/preview/attivita/[id].vue")
  },
  {
    name: "preview-attivita-id___en",
    path: "/en/preview/attivita/:id()",
    component: () => import("/app/app/pages/preview/attivita/[id].vue")
  },
  {
    name: "preview-attivita-id___fr",
    path: "/fr/preview/attivita/:id()",
    component: () => import("/app/app/pages/preview/attivita/[id].vue")
  },
  {
    name: "preview-prodotti-id___it",
    path: "/it/preview/prodotti/:id()",
    component: () => import("/app/app/pages/preview/prodotti/[id].vue")
  },
  {
    name: "preview-prodotti-id___en",
    path: "/en/preview/prodotti/:id()",
    component: () => import("/app/app/pages/preview/prodotti/[id].vue")
  },
  {
    name: "preview-prodotti-id___fr",
    path: "/fr/preview/prodotti/:id()",
    component: () => import("/app/app/pages/preview/prodotti/[id].vue")
  },
  {
    name: "dashboard-login-forgot___it",
    path: "/it/dashboard/login/forgot",
    component: () => import("/app/app/pages/dashboard/login/forgot.vue")
  },
  {
    name: "dashboard-login-forgot___en",
    path: "/en/dashboard/login/forgot",
    component: () => import("/app/app/pages/dashboard/login/forgot.vue")
  },
  {
    name: "dashboard-login-forgot___fr",
    path: "/fr/dashboard/login/forgot",
    component: () => import("/app/app/pages/dashboard/login/forgot.vue")
  },
  {
    name: "l-news_convention-id",
    path: "/l/news_convention/:id()",
    component: () => import("/app/app/pages/l/news_convention/[id].vue")
  },
  {
    name: "preview-pacchetti-id___it",
    path: "/it/preview/pacchetti/:id()",
    component: () => import("/app/app/pages/preview/pacchetti/[id].vue")
  },
  {
    name: "preview-pacchetti-id___en",
    path: "/en/preview/pacchetti/:id()",
    component: () => import("/app/app/pages/preview/pacchetti/[id].vue")
  },
  {
    name: "preview-pacchetti-id___fr",
    path: "/fr/preview/pacchetti/:id()",
    component: () => import("/app/app/pages/preview/pacchetti/[id].vue")
  },
  {
    name: "dashboard-outdoor___it",
    path: "/it/dashboard/outdoor",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/app/pages/dashboard/outdoor/index.vue")
  },
  {
    name: "dashboard-outdoor___en",
    path: "/en/dashboard/outdoor",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/app/pages/dashboard/outdoor/index.vue")
  },
  {
    name: "dashboard-outdoor___fr",
    path: "/fr/dashboard/outdoor",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/app/pages/dashboard/outdoor/index.vue")
  },
  {
    name: "dashboard-incoming___it",
    path: "/it/dashboard/incoming",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/app/pages/dashboard/incoming/index.vue")
  },
  {
    name: "dashboard-incoming___en",
    path: "/en/dashboard/incoming",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/app/pages/dashboard/incoming/index.vue")
  },
  {
    name: "dashboard-incoming___fr",
    path: "/fr/dashboard/incoming",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/app/pages/dashboard/incoming/index.vue")
  },
  {
    name: "checkout-success-ordine___it",
    path: "/it/checkout/success/:ordine()",
    component: () => import("/app/app/pages/checkout/success/[ordine].vue")
  },
  {
    name: "checkout-success-ordine___en",
    path: "/en/checkout/success/:ordine()",
    component: () => import("/app/app/pages/checkout/success/[ordine].vue")
  },
  {
    name: "checkout-success-ordine___fr",
    path: "/fr/checkout/success/:ordine()",
    component: () => import("/app/app/pages/checkout/success/[ordine].vue")
  },
  {
    name: "dashboard-armonia-acquista___it",
    path: "/it/dashboard/armonia/acquista",
    component: () => import("/app/app/pages/dashboard/armonia/acquista.vue")
  },
  {
    name: "dashboard-armonia-acquista___en",
    path: "/en/dashboard/armonia/acquista",
    component: () => import("/app/app/pages/dashboard/armonia/acquista.vue")
  },
  {
    name: "dashboard-armonia-acquista___fr",
    path: "/fr/dashboard/armonia/acquista",
    component: () => import("/app/app/pages/dashboard/armonia/acquista.vue")
  },
  {
    name: "dashboard-armonia-gestisci___it",
    path: "/it/dashboard/armonia/gestisci",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/armonia/gestisci.vue")
  },
  {
    name: "dashboard-armonia-gestisci___en",
    path: "/en/dashboard/armonia/gestisci",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/armonia/gestisci.vue")
  },
  {
    name: "dashboard-armonia-gestisci___fr",
    path: "/fr/dashboard/armonia/gestisci",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/armonia/gestisci.vue")
  },
  {
    name: "dashboard-profilo-modifica___it",
    path: "/it/dashboard/profilo/modifica",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/modifica.vue")
  },
  {
    name: "dashboard-profilo-modifica___en",
    path: "/en/dashboard/profilo/modifica",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/modifica.vue")
  },
  {
    name: "dashboard-profilo-modifica___fr",
    path: "/fr/dashboard/profilo/modifica",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/modifica.vue")
  },
  {
    name: "preview-visite-guidate-id___it",
    path: "/it/preview/visite-guidate/:id()",
    component: () => import("/app/app/pages/preview/visite-guidate/[id].vue")
  },
  {
    name: "preview-visite-guidate-id___en",
    path: "/en/preview/visite-guidate/:id()",
    component: () => import("/app/app/pages/preview/visite-guidate/[id].vue")
  },
  {
    name: "preview-visite-guidate-id___fr",
    path: "/fr/preview/visite-guidate/:id()",
    component: () => import("/app/app/pages/preview/visite-guidate/[id].vue")
  },
  {
    name: "acquista-visite-guidate-id___it",
    path: "/it/acquista/visite-guidate/:id()",
    component: () => import("/app/app/pages/acquista/visite-guidate/[id].vue")
  },
  {
    name: "acquista-visite-guidate-id___en",
    path: "/en/acquista/visite-guidate/:id()",
    component: () => import("/app/app/pages/acquista/visite-guidate/[id].vue")
  },
  {
    name: "acquista-visite-guidate-id___fr",
    path: "/fr/acquista/visite-guidate/:id()",
    component: () => import("/app/app/pages/acquista/visite-guidate/[id].vue")
  },
  {
    name: "dashboard-outdoor-crea___it",
    path: "/it/dashboard/outdoor/crea",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/app/pages/dashboard/outdoor/crea/index.vue")
  },
  {
    name: "dashboard-outdoor-crea___en",
    path: "/en/dashboard/outdoor/crea",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/app/pages/dashboard/outdoor/crea/index.vue")
  },
  {
    name: "dashboard-outdoor-crea___fr",
    path: "/fr/dashboard/outdoor/crea",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/app/pages/dashboard/outdoor/crea/index.vue")
  },
  {
    name: "dashboard-profilo-card___it",
    path: "/it/dashboard/profilo/card",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/card/index.vue")
  },
  {
    name: "dashboard-profilo-card___en",
    path: "/en/dashboard/profilo/card",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/card/index.vue")
  },
  {
    name: "dashboard-profilo-card___fr",
    path: "/fr/dashboard/profilo/card",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/card/index.vue")
  },
  {
    name: "dashboard-ristorazione___it",
    path: "/it/dashboard/ristorazione",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/app/pages/dashboard/ristorazione/index.vue")
  },
  {
    name: "dashboard-ristorazione___en",
    path: "/en/dashboard/ristorazione",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/app/pages/dashboard/ristorazione/index.vue")
  },
  {
    name: "dashboard-ristorazione___fr",
    path: "/fr/dashboard/ristorazione",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/app/pages/dashboard/ristorazione/index.vue")
  },
  {
    name: "dashboard-incoming-crea___it",
    path: "/it/dashboard/incoming/crea",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/app/pages/dashboard/incoming/crea/index.vue")
  },
  {
    name: "dashboard-incoming-crea___en",
    path: "/en/dashboard/incoming/crea",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/app/pages/dashboard/incoming/crea/index.vue")
  },
  {
    name: "dashboard-incoming-crea___fr",
    path: "/fr/dashboard/incoming/crea",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/app/pages/dashboard/incoming/crea/index.vue")
  },
  {
    name: "dashboard-registrazione___it",
    path: "/it/dashboard/registrazione",
    component: () => import("/app/app/pages/dashboard/registrazione/index.vue")
  },
  {
    name: "dashboard-registrazione___en",
    path: "/en/dashboard/registrazione",
    component: () => import("/app/app/pages/dashboard/registrazione/index.vue")
  },
  {
    name: "dashboard-registrazione___fr",
    path: "/fr/dashboard/registrazione",
    component: () => import("/app/app/pages/dashboard/registrazione/index.vue")
  },
  {
    name: "dashboard-profilo-ordini___it",
    path: "/it/dashboard/profilo/ordini",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/ordini/index.vue")
  },
  {
    name: "dashboard-profilo-ordini___en",
    path: "/en/dashboard/profilo/ordini",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/ordini/index.vue")
  },
  {
    name: "dashboard-profilo-ordini___fr",
    path: "/fr/dashboard/profilo/ordini",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/ordini/index.vue")
  },
  {
    name: "dashboard-registrazione-invito___it",
    path: "/it/dashboard/registrazione/invito",
    meta: {"middleware":["registra-invito"]},
    component: () => import("/app/app/pages/dashboard/registrazione/invito.vue")
  },
  {
    name: "dashboard-registrazione-invito___en",
    path: "/en/dashboard/registrazione/invito",
    meta: {"middleware":["registra-invito"]},
    component: () => import("/app/app/pages/dashboard/registrazione/invito.vue")
  },
  {
    name: "dashboard-registrazione-invito___fr",
    path: "/fr/dashboard/registrazione/invito",
    meta: {"middleware":["registra-invito"]},
    component: () => import("/app/app/pages/dashboard/registrazione/invito.vue")
  },
  {
    name: "dashboard-outdoor-modifica-id___it",
    path: "/it/dashboard/outdoor/modifica/:id()",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/app/pages/dashboard/outdoor/modifica/[id].vue")
  },
  {
    name: "dashboard-outdoor-modifica-id___en",
    path: "/en/dashboard/outdoor/modifica/:id()",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/app/pages/dashboard/outdoor/modifica/[id].vue")
  },
  {
    name: "dashboard-outdoor-modifica-id___fr",
    path: "/fr/dashboard/outdoor/modifica/:id()",
    meta: {"middleware":["private-area-operatori-outdoor"]},
    component: () => import("/app/app/pages/dashboard/outdoor/modifica/[id].vue")
  },
  {
    name: "dashboard-outdoor-registrazione___it",
    path: "/it/dashboard/outdoor/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/outdoor/registrazione.vue")
  },
  {
    name: "dashboard-outdoor-registrazione___en",
    path: "/en/dashboard/outdoor/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/outdoor/registrazione.vue")
  },
  {
    name: "dashboard-outdoor-registrazione___fr",
    path: "/fr/dashboard/outdoor/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/outdoor/registrazione.vue")
  },
  {
    name: "dashboard-promuovi-evento___it",
    path: "/it/dashboard/promuovi-evento",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/promuovi-evento/index.vue")
  },
  {
    name: "dashboard-promuovi-evento___en",
    path: "/en/dashboard/promuovi-evento",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/promuovi-evento/index.vue")
  },
  {
    name: "dashboard-promuovi-evento___fr",
    path: "/fr/dashboard/promuovi-evento",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/promuovi-evento/index.vue")
  },
  {
    name: "dashboard-incoming-modifica-id___it",
    path: "/it/dashboard/incoming/modifica/:id()",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/app/pages/dashboard/incoming/modifica/[id].vue")
  },
  {
    name: "dashboard-incoming-modifica-id___en",
    path: "/en/dashboard/incoming/modifica/:id()",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/app/pages/dashboard/incoming/modifica/[id].vue")
  },
  {
    name: "dashboard-incoming-modifica-id___fr",
    path: "/fr/dashboard/incoming/modifica/:id()",
    meta: {"middleware":["private-area-operatori-incoming"]},
    component: () => import("/app/app/pages/dashboard/incoming/modifica/[id].vue")
  },
  {
    name: "dashboard-incoming-registrazione___it",
    path: "/it/dashboard/incoming/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/incoming/registrazione.vue")
  },
  {
    name: "dashboard-incoming-registrazione___en",
    path: "/en/dashboard/incoming/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/incoming/registrazione.vue")
  },
  {
    name: "dashboard-incoming-registrazione___fr",
    path: "/fr/dashboard/incoming/registrazione",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/incoming/registrazione.vue")
  },
  {
    name: "dashboard-ristorazione-crea___it",
    path: "/it/dashboard/ristorazione/crea",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/ristorazione/crea/index.vue")
  },
  {
    name: "dashboard-ristorazione-crea___en",
    path: "/en/dashboard/ristorazione/crea",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/ristorazione/crea/index.vue")
  },
  {
    name: "dashboard-ristorazione-crea___fr",
    path: "/fr/dashboard/ristorazione/crea",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/ristorazione/crea/index.vue")
  },
  {
    name: "dashboard-armonia-calendario___it",
    path: "/it/dashboard/armonia/calendario",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/armonia/calendario/index.vue")
  },
  {
    name: "dashboard-armonia-calendario___en",
    path: "/en/dashboard/armonia/calendario",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/armonia/calendario/index.vue")
  },
  {
    name: "dashboard-armonia-calendario___fr",
    path: "/fr/dashboard/armonia/calendario",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/armonia/calendario/index.vue")
  },
  {
    name: "dashboard-profilo-prenotazioni___it",
    path: "/it/dashboard/profilo/prenotazioni",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/prenotazioni/index.vue")
  },
  {
    name: "dashboard-profilo-prenotazioni___en",
    path: "/en/dashboard/profilo/prenotazioni",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/prenotazioni/index.vue")
  },
  {
    name: "dashboard-profilo-prenotazioni___fr",
    path: "/fr/dashboard/profilo/prenotazioni",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/prenotazioni/index.vue")
  },
  {
    name: "dashboard-ristorazione-modifica-id___it",
    path: "/it/dashboard/ristorazione/modifica/:id()",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/app/pages/dashboard/ristorazione/modifica/[id].vue")
  },
  {
    name: "dashboard-ristorazione-modifica-id___en",
    path: "/en/dashboard/ristorazione/modifica/:id()",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/app/pages/dashboard/ristorazione/modifica/[id].vue")
  },
  {
    name: "dashboard-ristorazione-modifica-id___fr",
    path: "/fr/dashboard/ristorazione/modifica/:id()",
    meta: {"middleware":["private-area-ristoratori"]},
    component: () => import("/app/app/pages/dashboard/ristorazione/modifica/[id].vue")
  },
  {
    name: "dashboard-promuovi-ristorazione___it",
    path: "/it/dashboard/promuovi-ristorazione",
    meta: indexH8k0nBO3MLKbykhUTssNRvV6Atuty_s2VY_ghpT1MxAMeta || {},
    component: () => import("/app/app/pages/dashboard/promuovi-ristorazione/index.vue")
  },
  {
    name: "dashboard-promuovi-ristorazione___en",
    path: "/en/dashboard/promuovi-ristorazione",
    meta: indexH8k0nBO3MLKbykhUTssNRvV6Atuty_s2VY_ghpT1MxAMeta || {},
    component: () => import("/app/app/pages/dashboard/promuovi-ristorazione/index.vue")
  },
  {
    name: "dashboard-promuovi-ristorazione___fr",
    path: "/fr/dashboard/promuovi-ristorazione",
    meta: indexH8k0nBO3MLKbykhUTssNRvV6Atuty_s2VY_ghpT1MxAMeta || {},
    component: () => import("/app/app/pages/dashboard/promuovi-ristorazione/index.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug___it",
    path: "/it/dashboard/armonia/calendario/:slug()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/armonia/calendario/[slug]/index.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug___en",
    path: "/en/dashboard/armonia/calendario/:slug()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/armonia/calendario/[slug]/index.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug___fr",
    path: "/fr/dashboard/armonia/calendario/:slug()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/armonia/calendario/[slug]/index.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug-prenota___it",
    path: "/it/dashboard/armonia/calendario/:slug()/prenota",
    meta: {"middleware":["private-area-armonia-prenota"]},
    component: () => import("/app/app/pages/dashboard/armonia/calendario/[slug]/prenota.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug-prenota___en",
    path: "/en/dashboard/armonia/calendario/:slug()/prenota",
    meta: {"middleware":["private-area-armonia-prenota"]},
    component: () => import("/app/app/pages/dashboard/armonia/calendario/[slug]/prenota.vue")
  },
  {
    name: "dashboard-armonia-calendario-slug-prenota___fr",
    path: "/fr/dashboard/armonia/calendario/:slug()/prenota",
    meta: {"middleware":["private-area-armonia-prenota"]},
    component: () => import("/app/app/pages/dashboard/armonia/calendario/[slug]/prenota.vue")
  },
  {
    name: "dashboard-profilo-card-abbonamenti-athena-id___it",
    path: "/it/dashboard/profilo/card/abbonamenti-athena/:id()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/card/abbonamenti-athena/[id].vue")
  },
  {
    name: "dashboard-profilo-card-abbonamenti-athena-id___en",
    path: "/en/dashboard/profilo/card/abbonamenti-athena/:id()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/card/abbonamenti-athena/[id].vue")
  },
  {
    name: "dashboard-profilo-card-abbonamenti-athena-id___fr",
    path: "/fr/dashboard/profilo/card/abbonamenti-athena/:id()",
    meta: {"middleware":["private-area"]},
    component: () => import("/app/app/pages/dashboard/profilo/card/abbonamenti-athena/[id].vue")
  },
  {
    name: "visita-pianifica-la-tua-visita-torino-piemonte-card___it",
    path: "/it/visita/pianifica-la-tua-visita/torino-piemonte-card",
    meta: torino_45piemonte_45card_nprFiEv0ojirWFi3qY9XOU_5pX02G1b5ZLlhW3ZhM8Meta || {},
    component: () => import("/app/app/pages/visita/pianifica-la-tua-visita/torino-piemonte-card.vue")
  },
  {
    name: "visita-pianifica-la-tua-visita-torino-piemonte-card___en",
    path: "/en/visit/plan-your-trip/torino-piemonte-card",
    meta: torino_45piemonte_45card_nprFiEv0ojirWFi3qY9XOU_5pX02G1b5ZLlhW3ZhM8Meta || {},
    component: () => import("/app/app/pages/visita/pianifica-la-tua-visita/torino-piemonte-card.vue")
  },
  {
    name: "visita-pianifica-la-tua-visita-torino-piemonte-card___fr",
    path: "/fr/decouvrir/preparer-ton-sejour/torino-piemonte-card",
    meta: torino_45piemonte_45card_nprFiEv0ojirWFi3qY9XOU_5pX02G1b5ZLlhW3ZhM8Meta || {},
    component: () => import("/app/app/pages/visita/pianifica-la-tua-visita/torino-piemonte-card.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: "node-id__it",
    path: "/it/node/:id",
    meta: {"middleware":["search-node-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "node-id__en",
    path: "/en/node/:id",
    meta: {"middleware":["search-node-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "node-id__fr",
    path: "/fr/node/:id",
    meta: {"middleware":["search-node-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-pagine-id__it",
    path: "/it/l/pagine/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-pagine-id__en",
    path: "/en/l/pagine/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-pagine-id__fr",
    path: "/fr/l/pagine/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-risorse-id__it",
    path: "/it/l/risorse/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-risorse-id__en",
    path: "/en/l/risorse/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-risorse-id__fr",
    path: "/fr/l/risorse/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-eventi-id__it",
    path: "/it/l/eventi/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-eventi-id__en",
    path: "/en/l/eventi/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-eventi-id__fr",
    path: "/fr/l/eventi/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-prodotti-id__it",
    path: "/it/l/prodotti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-prodotti-id__en",
    path: "/en/l/prodotti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-prodotti-id__fr",
    path: "/fr/l/prodotti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-attivita-id__it",
    path: "/it/l/attivita/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-attivita-id__en",
    path: "/en/l/attivita/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-attivita-id__fr",
    path: "/fr/l/attivita/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-pacchetti-id__it",
    path: "/it/l/pacchetti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-pacchetti-id__en",
    path: "/en/l/pacchetti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-pacchetti-id__fr",
    path: "/fr/l/pacchetti/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-news_convention-id__it",
    path: "/it/l/news_convention/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-news_convention-id__en",
    path: "/en/l/news_convention/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-news_convention-id__fr",
    path: "/fr/l/news_convention/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-visite_guidate-id__it",
    path: "/it/l/visite_guidate/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-visite_guidate-id__en",
    path: "/en/l/visite_guidate/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-visite_guidate-id__fr",
    path: "/fr/l/visite_guidate/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-spettacoli-id__it",
    path: "/it/l/spettacoli/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-spettacoli-id__en",
    path: "/en/l/spettacoli/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  },
  {
    name: "l-spettacoli-id__fr",
    path: "/fr/l/spettacoli/:id",
    meta: {"middleware":["search-link-redirect"]},
    component: () => import("/app/app/pages/node/[id].vue")
  }
]